import { ShotMissedOutcomeTypes } from "../Constants";

export const ModifyShotMissedOutcomeType = {
  name: "shot-missed-outcome-type",
  component: "MainPanel",
  layout: "main-panel x-large",
  mode: "visible",
  text: "shot.outcome-type",
  showOn: [
    { state: "editState", value: "shot-missed-outcome-type", operator: "is" },
  ],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "shot-missed-outcome-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "singleOption",
        optionName: "failureReason",
        children: ShotMissedOutcomeTypes,
        layout: "type-button",
        prefix: "failureReason",
        type: "edit",
      },
      actionGroups: [
        {
          actions: [
            // TODO: add insert new block event if specific outcome type was selected
            { action: "sendEvent", value: "edit", type: "edit" },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
